import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathNotes: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="math-notes, function"><path d="M12 3.75V20.25M3.75 12H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 19.25C12 19.25 12 4.75 20.25 4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.25 5.25L7 6.96429M7 6.96429L8.75 5.25M7 6.96429V9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 15.25L18.75 18.75M18.75 15.25L15.25 18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMathNotes;
